import React, { useState } from "react";
import { DownArrow, UpArrow } from "../../assets/svg";

const DropdownCheckbox = ({
  label,
  children,
  buttonClass,
  form,
  isOpen,
  indexOnChange,
  inputChecked,
  inputNameId,
}) => {
  const [open, setOpen] = useState(isOpen ?? false);

  const toggleDropdown = () => {
    setOpen(!open);
  };

  return (
    <div className="relative">
      <label form={form}>
        <div className="flex  items-center gap-2">
          <button
            type="button"
            onClick={toggleDropdown}
            className={buttonClass}
          >
            <input
              type="checkbox"
              id={inputNameId}
              name={inputNameId}
              className="w-4 h-4 mr-2 accent-themeBtn "
              checked={inputChecked}
              onChange={indexOnChange}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
            />
            <p className="font-Proxima">{label}</p>
          </button>
          {open ? <UpArrow /> : <DownArrow />}
        </div>
      </label>
      {open && <div>{children}</div>}
    </div>
  );
};

export default DropdownCheckbox;
